import React, { Component } from 'react';

import axios from 'axios';
import { withStyles } from '@material-ui/core/styles';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';

import {API, STORAGE_URL} from "../../../../config";
import Util from "../../../../yeffect/utils";
import { Button } from "@material-ui/core";
import classNames from 'classnames';
//var moment = require('moment');

const uploadedFiles = API.service('uploaded-files');
//const inbound = API.service('inbound-transfers');

const styles = theme => ({
  button: {
    margin: '5px auto',
    textAlign: 'right'
  },
  leftIcon: {
    marginRight: theme.spacing.unit
  },
  rightIcon: {
    marginLeft: theme.spacing.unit
  },
  iconSmall: {
    fontSize: 20
  },
  photoSquare: {
    width: '100%'
  },
  status: {
    width: '80%',
    margin: '5px auto',
    padding: '7px',
    fontSize: '12px'
  },

  uploading: {
    position:'absolute',
    top:0,
    bottom:0,
    left:0,
    right:0,
    background: 'rgba(0,0,0,0.8)',
    padding:38,
    borderRadius:5,
    zIndex:1000,
    fontSize:24
  }
});

class Document extends Component {
  constructor(props) {
    super(props)

    this.account = JSON.parse(Util.readCookie('account'));

    this.state = {
      passportMessage: null,
      passportStatus: '',
      uploadedCnt: 0,
      uploadProgress: 0,
      whichUpload: 'photograph',
      blah: this.props.dumb,
      uploading: false,
    }

    this.photograph = (this.props.placeholder.length) ? this.props.placeholder : '/default_photo.jpg';

    this.uploadFile = this.uploadFile.bind(this)
    this.turnOnCam = this.turnOnCam.bind(this)

  }

  componentDidMount() {
    //var app = this;

  }

  render() {

    const { classes ,t} = this.props;

    return (
      <div className="DocManagesr">
        <div className={classNames(this.state.whichUpload)}>
          {(this.state.uploading) &&
            <div className={classes.uploading}>
              <i className="fa fa-spinner fa-spin"></i> Uploading {this.state.uploadProgress}%
            </div>
          }
          <div className="photoSquare selfie">
            {(this.photograph === this.props.placeholder) &&
              <Button className={classes.button} variant="contained" color="secondary" onClick={(this.props.trigger) ? this.props.trigger : this.turnOnCam}>
                {this.props.label}
                <CloudUploadIcon className={classes.rightIcon} />
              </Button>
            }

            {(this.photograph !== this.props.placeholder) &&
              <p>{t('account_add_funds_wire_instructions_receipt_uploaded')}</p>
            }
            <form id="uploadForm" encType="multipart/form-data" onChange={this.uploadFile}>
              <input style={{ visibility: 'hidden' }} type="file" ref="upload" id="file" name="file" />
            </form>
          </div>
        </div>
      </div>
    );
  }

  takePhoto = (event) => {
    this.setState({ whichUpload: "photograph" });
  }

  uploadFile(event) {
    var controller = this;
    var formData = new FormData();

    formData.append("file", event.target.files[0], event.target.files[0].name);
    formData.append("fieldname", this.props.type);
    formData.append("account", this.props.request_id);

    var payload = {
      assoc_id: this.props.assoc_id,
      orig_filename: event.target.files[0].name,
      status: 1,
      fieldname: this.props.type,
      upload_type: this.props.uploadType,
      request_id: (typeof this.props.request_id !== "undefined") ? this.props.request_id : null
    }

    controller.setState({ uploading: true });
    controller.setState({ uploadProgress: 0 });

    axios.post(STORAGE_URL, formData, {
      headers: {
        'content-type': 'multipart/form-data'
      },
      onUploadProgress: function (progressEvent) {
        controller.setState({ uploading: true, uploadProgress: Math.round((progressEvent.loaded * 100) / progressEvent.total) });
      }
    }).then(i => {
      payload.system_filename = i.data.img;
      //var file = i.data.img;
      uploadedFiles.create(payload).then(i => {
        if (typeof this.props.onComplete === 'function') {
          console.log('complete_triggered');
          controller.setState({ uploading: false });
          this.props.onComplete(i);
        }
      });
    });
  }

  turnOnCam() {
    this.refs.upload.click()
  }
}

export default withStyles(styles)(Document);



// WEBPACK FOOTER //
// ./src/main/content/isinApplications/components/UploadDocument.js